var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667 6.857H6c.368 0 .667.192.667.429v.857c0 .237-.299.428-.667.428H.667C.298 8.571 0 8.38 0 8.143v-.857c0-.237.298-.429.667-.429zm0 3.429h2.666c.369 0 .667.191.667.428v.857c0 .237-.298.429-.667.429H.667C.298 12 0 11.808 0 11.57v-.857c0-.237.298-.428.667-.428z",
    fill: "#CFE6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.667 3.428h-8c-.369 0-.667.192-.667.429v.857c0 .237.298.429.667.429h8c.368 0 .666-.192.666-.429v-.857c0-.237-.298-.429-.666-.429zM11.333 0H.667C.298 0 0 .192 0 .429v.857c0 .236.298.428.667.428h10.666c.368 0 .667-.192.667-.428V.429C12 .192 11.701 0 11.333 0z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSort);
export default __webpack_public_path__ + "static/media/ic-sort.a46539537166f80ab927792c710b0845.svg";
export { ForwardRef as ReactComponent };